import React, { startTransition, useCallback, useState } from 'react';
import { hydrateRoot } from 'react-dom/client';

import createEmotionCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { RemixBrowser } from '@remix-run/react';

import { RemixApptoolboxInject } from 'platform/components/RemixApptoolboxInject';
import { ODTeamBoundary } from 'platform/ODTeamBoundary';
import { ClientStyleContext } from 'platform/styles/client.context';

function ClientCacheProvider({ children }: { children: React.ReactNode }) {
  const [cache, setCache] = useState(createEmotionCache({ key: 'css' }));

  const reset = useCallback(() => {
    return setCache(createEmotionCache({ key: 'css' }));
  }, []);

  return (
    <ClientStyleContext.Provider value={{ reset }}>
      <CacheProvider value={cache}>{children}</CacheProvider>
    </ClientStyleContext.Provider>
  );
}

const hydrate = () => {
  startTransition(() => {
    hydrateRoot(
      // eslint-disable-next-line ssr-friendly/no-dom-globals-in-module-scope -- enabled for client entry
      document,
      <ODTeamBoundary team="consumer-platform">
        <ClientCacheProvider>
          <RemixApptoolboxInject />
          <RemixBrowser />
        </ClientCacheProvider>
      </ODTeamBoundary>,
    );
  });
};

if (typeof requestIdleCallback === 'function') {
  requestIdleCallback(hydrate);
} else {
  // Safari doesn't support requestIdleCallback
  // https://caniuse.com/requestidlecallback
  setTimeout(hydrate, 1);
}
